// src/store/thunks/users/fetchInvitationLinkThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { InvitationResponse } from '@/types/users.types';
import { isAPIError } from '@/store/utils';
import type { RejectValue } from '@/types/thunk.types';
import { setErrorMessage, setHideLoader, setShowLoader } from '@/store/slices/ui/UISlice';

export const fetchInvitationLinkThunk = createAdminAsyncThunk<
  InvitationResponse,
  { userId: string; intervalMs?: number; timeoutMs?: number },
  { rejectValue: RejectValue }
>(
  'users/fetchInvitationLink',
  async({ userId, intervalMs, timeoutMs }, { extra: { usersService }, signal, rejectWithValue, dispatch }) => {
    dispatch(setShowLoader());
    try {
      // ⬇️ Pass the thunk's AbortSignal down to the service
      return await usersService.waitForInvitationLink(userId, { intervalMs, timeoutMs, signal });
    } catch (unknownError: unknown) {
      if (isAPIError(unknownError) && unknownError.fieldErrors !== null) {
        dispatch(setErrorMessage(unknownError.message));
        return rejectWithValue({ fieldErrors: {} });
      }

      const message =
        unknownError instanceof DOMException && unknownError.name === 'AbortError'
          ? 'Request aborted'
          : unknownError instanceof Error
            ? unknownError.message
            : 'Failed to fetch invitation link';

      return rejectWithValue({ message });
    }
    finally { dispatch(setHideLoader());}
  }
);
